var app = {
	header: {
		closeButton: "Đóng",
		copyrightLabel: "Bản quyền",
		helpLabel: "Trợ giúp",
		legalNoticeLabel: "Thông báo pháp lý",
		logoutButton: "Đăng xuất",
		menuLabel: "Menu",
		noUserDataLabel: "Không có dữ liệu người dùng",
		notificationsLabel: "Thông báo",
		privacyPolicyLabel: "Chính sách bảo mật",
		serviceAppLabel: "Ứng dụng Dịch vụ",
		settingsLabel: "Cài đặt",
		shopLabel: "Cửa hàng",
		smartFactorySuiteLabel: "Bộ công cụ Nhà máy Thông minh",
		userLabel: "Hồ sơ",
		userProfileLinkText: "Hồ sơ Người dùng"
	}
};
var contentLoadingError = "Không thể tải nội dung";
var dashboard = {
	cancel: {
		button: "Hủy"
	},
	edit: {
		button: "Chỉnh sửa"
	},
	reset: {
		button: "Đặt lại"
	},
	save: {
		button: "Lưu"
	},
	share: {
		button: "Chia sẻ"
	}
};
var filter = {
	clear: "Đặt lại bộ lọc",
	clearAll: "Đặt lại tất cả bộ lọc"
};
var locationMap = {
	locationLink: {
		label: "Đi tới vị trí"
	}
};
var machineDiscontinuation = {
	linkText: "Tìm hiểu thêm"
};
var notifications = {
	button: {
		loadMore: "Tải thêm"
	},
	date: {
		lastMonth: "Tháng trước",
		lastWeek: "Tuần trước",
		older: "Cũ hơn",
		thisMonth: "Tháng này",
		thisWeek: "Tuần này",
		today: "Hôm nay",
		yesterday: "Hôm qua"
	},
	error: {
		general: "Hiện không thể hiển thị thông báo. Vui lòng thử lại sau.",
		unauthorized: "Vui lòng đăng nhập để xem thông báo"
	},
	info: {
		activateSettings: "Để nhận thông báo, vui lòng kích hoạt chúng trong cài đặt",
		noNotification: "Hiện tại không có tin nhắn nào cho bạn."
	},
	title: "Thông báo"
};
var results = {
	counter: {
		label: "Kết quả"
	}
};
var scrollToTop = {
	label: "Cuộn lên đầu trang"
};
var slider = {
	nextButton: {
		label: "Trang sau"
	},
	paginationBullet: {
		label: "Trang"
	},
	prevButton: {
		label: "Trang trước"
	}
};
var sorting = {
	ascending: "Tăng dần",
	descending: "Giảm dần"
};
var userAccount = {
	address: {
		label: "Địa chỉ bưu điện"
	},
	email: {
		label: "Email"
	},
	language: {
		label: "Ngôn ngữ",
		locale: "Địa phương",
		select: "Chọn ngôn ngữ",
		settings: "Cài đặt ngôn ngữ"
	},
	loggedOut: {
		message: "Bạn chưa đăng nhập"
	},
	login: {
		button: "Đăng nhập"
	},
	name: {
		label: "Tên"
	},
	phone: {
		label: "Điện thoại"
	}
};
var widget = {
	filter: {
		machine: {
			filter: "Lọc máy móc",
			label: "Máy móc",
			option: {
				all: "Tất cả máy móc"
			},
			select: "Chọn máy móc"
		},
		period: {
			label: "Khoảng thời gian",
			option: {
				currentMonth: "Tháng này",
				currentWeek: "Tuần này",
				lastMonth: "Tháng trước",
				lastWeek: "Tuần trước",
				today: "Hôm nay",
				yesterday: "Hôm qua"
			}
		}
	}
};
var widgetRegistry = {
	allWidgets: {
		label: "Các tiện ích của tôi"
	},
	noDescriptionAvailable: "Không có mô tả nào.",
	widget: {
		SampleMyMachines: {
			title: "Các máy của tôi"
		},
		SampleMyServiceCalls: {
			title: "Cuộc gọi dịch vụ"
		},
		SampleMyTrackingList: {
			title: "Danh sách theo dõi"
		},
		SampleMyUserAccount: {
			title: "Hồ sơ của tôi"
		},
		SampleOperationalStatesChart: {
			title: "Trạng thái hoạt động"
		},
		SampleWidgetFilter: {
			title: "Cài đặt bộ lọc"
		},
		SampleWorkloadBalanceChart: {
			title: "Cân đối công việc"
		}
	}
};
var translation = {
	app: app,
	contentLoadingError: contentLoadingError,
	dashboard: dashboard,
	filter: filter,
	locationMap: locationMap,
	machineDiscontinuation: machineDiscontinuation,
	notifications: notifications,
	results: results,
	scrollToTop: scrollToTop,
	slider: slider,
	sorting: sorting,
	userAccount: userAccount,
	widget: widget,
	widgetRegistry: widgetRegistry
};

export { app, contentLoadingError, dashboard, translation as default, filter, locationMap, machineDiscontinuation, notifications, results, scrollToTop, slider, sorting, userAccount, widget, widgetRegistry };
